import { alpha, Box, Stack, styled, Typography } from "@mui/material";
import { FlexBox } from "@/components/baseComponents/FlexBox";
import { CenteredBox } from "@/components/baseComponents/CenteredBox";

export const StyledContainer = styled(FlexBox)(({ theme }) => ({
  maxWidth: "1200px",
  flexDirection: "row",
  columnGap: "40px",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: "0 50px",
  borderRadius: "8px",
  backgroundColor: alpha(theme.palette.common.white, 0.6),
  wrap: "nowrap",

  [theme.breakpoints.down("desktop")]: {
    rowGap: "40px",
    paddingLeft: "24px",
    paddingRight: "24px",
  },

  [theme.breakpoints.down("tablet")]: {
    rowGap: "32px",
    padding: "16px",
  },
}));

export const StyledRobotContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexShrink: 0,

  [theme.breakpoints.down("desktop")]: {
    width: "100%",
    maxWidth: "205px",
  },

  [theme.breakpoints.down("tablet")]: {
    display: "none",
  },
}));

export const StyledDesktopRobot = styled("img")(({ theme }) => ({
  maxWidth: "285px",
  display: "block",

  [theme.breakpoints.down("desktop")]: {
    display: "none",
  },
}));

export const StyledTabletRobot = styled("img")(({ theme }) => ({
  maxWidth: "205px",
  display: "none",

  [theme.breakpoints.down("desktop")]: {
    display: "block",
  },
}));

export const StyledContentContainer = styled(Stack)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  flex: 1,

  [theme.breakpoints.down("tablet")]: {
    paddingTop: "16px",
    alignItems: "center",
  },
}));

export const StyledTagsContainer = styled(FlexBox)(() => ({
  justifyContent: "center",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: "8px",
  marginTop: "8px",
}));

export const StyledTag = styled(CenteredBox)(({ theme }) => ({
  padding: "6px 12px",
  fontSize: "16px",
  fontWeight: "600",
  lineHeight: "18px",
  border: "2px solid transparent",
  borderRadius: "10000px",
  background:
    "linear-gradient(white, white) padding-box, linear-gradient(to bottom, #E3CE00, #FFB526) border-box",
  backgroundClip: "padding-box, border-box",

  [theme.breakpoints.down("desktop")]: {
    fontSize: "13px",
  },
}));

export const StyledDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.body2.fontSize,
  marginTop: "20px",
}));
